import { render, staticRenderFns } from "./PremadePlans.vue?vue&type=template&id=f3e7b1c8&scoped=true"
import script from "./PremadePlans.vue?vue&type=script&lang=ts"
export * from "./PremadePlans.vue?vue&type=script&lang=ts"
import style0 from "./PremadePlans.vue?vue&type=style&index=0&id=f3e7b1c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3e7b1c8",
  null
  
)

export default component.exports